/**
 * DIY browser logger aligned with the pino-style format used on Node.
 * In production, `info` is a no-op; only `warn`/`error` reach the console.
 * Each line is formatted with timestamp + level + message + context.
 */

type Level = 'info' | 'warn' | 'error';
type LogContext = Record<string, unknown>;

const isProd: boolean = import.meta.env.MODE === 'production';

function format(level: Level, message: string, context?: LogContext): string {
  const payload = {
    time: new Date().toISOString(),
    level,
    message,
    context: context ?? {},
  };
  return JSON.stringify(payload);
}

export const log = {
  info(message: string, context?: LogContext): void {
    if (isProd) return;
    console.info(format('info', message, context));
  },
  warn(message: string, context?: LogContext): void {
    console.warn(format('warn', message, context));
  },
  error(message: string, context?: LogContext): void {
    console.error(format('error', message, context));
  },
};

export type Logger = typeof log;
